import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import withWidth, { isWidthDown } from '@material-ui/core/withWidth'
import CircularProgress from '@material-ui/core/CircularProgress'

const styles = {
  centered: {
    margin: 'auto',
    display: 'block',
  },
}

const ContentLoader = ({ classes, centered, width }) => (
  <CircularProgress
    color="secondary"
    className={classNames({
      [classes.centered]: !isWidthDown('xs', width) && centered
    })}
  />
)

ContentLoader.propTypes = {
  classes: PropTypes.object.isRequired,
  centered: PropTypes.bool,
  width: PropTypes.string.isRequired,
}

export default withWidth()(withStyles(styles)(ContentLoader))
